import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addNotification } from 'reapop';
import { ListItem, Divider } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import { filter, map, get } from 'lodash';
import { push } from 'react-router-redux';

import { fetchBenefits } from 'actions/Benefits';
import KFlatButton from 'components/KJRN/KFlatButton';
import KBenefit from 'components/KJRN/KBenefit';
import styles from 'styles/TBenefits';
import { initUpload } from '../../actions/Files';
import { requestSendEmail } from '../../actions/Email';
import TLoading from './TLoading';
import TMessage from './TMessage';
import { benefitUpload, fitnessGrantRegisterAndUpload } from '../../actions/Benefits';

const TGrants = () => {
  const dispatch = useDispatch();
  const { BenefitsReducer, profileReducer } = useSelector(state => state);
  const { benefits, loaded, benefitLoadingById } = BenefitsReducer;
  const employeeName = get(profileReducer, ['employeeMaster', 'EmployeeName'], '');

  useEffect(() => {
    dispatch(fetchBenefits());
    dispatch(initUpload());
  }, []);

  if (!loaded) {
    return <TLoading />;
  }

  const gr = filter(benefits, (benefit => benefit.HrBenefitType === 1 || benefit.HrBenefitType === 2));

  if (!gr || !gr.length) {
    return <TMessage message="tile.grants.empty" />;
  }

  // const onBenefitUpload = (files, fileType, cb) => dispatch(uploadFiles({ files, fileType }, () => {
  //   cb && cb();
  //   dispatch(addNotification({
  //     title: 'Vistað',
  //     message: 'Viðhengi hefur verið vistað í skjalaskáp',
  //     status: 'success',
  //     dismissible: true,
  //     dismissAfter: 4000,
  //   }));
  // }));

  const onBenefitUpload = async (files, fileType, cb, Email, EmailCallBack) => dispatch(benefitUpload({ files, fileType }, cb, Email, EmailCallBack));

  const onSendEmail = email => dispatch(requestSendEmail(email, () => {
    dispatch(addNotification({
      title: 'Sent',
      message: 'Tölvupóstur hefur verið sendur með viðhengi',
      status: 'success',
      dismissible: true,
      dismissAfter: 4000,
    }));
  }));

  if (gr.length === 1) {
    const benefit = get(gr, 0);
    return (
      <KBenefit
        {...benefit}
        loading={get(benefitLoadingById, benefit.HrBenefitID, false)}
        onUpload={onBenefitUpload}
        onRequestGrant={(...args) => dispatch(fitnessGrantRegisterAndUpload(...args))}
        onEmail={onSendEmail}
        employeeName={employeeName}
      />
    );
  }

  return (
    <div style={styles.container} >
      <div style={{ maxHeight: 422, overflow: 'auto', height: '100%' }}>
        {map(gr, (grant, key) => (
          <div key={key}>
            <ListItem
              innerDivStyle={styles.link}
              primaryText={grant.HrBenefitName}
              hoverColor="transparent"
              onClick={() => dispatch(push('/grants'))}
            />
            <Divider key="div" style={styles.spacer} />
          </div>
          ))}
      </div>
      <KFlatButton
        data-cy="grants-button"
        style={styles.actionButton}
        onClick={() => dispatch(push('/grants'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.holiday.goto" />}
      />
    </div>
  );
};

export default TGrants;



// WEBPACK FOOTER //
// ./src/containers/tiles/TGrants.js